import React from "react";

function NotFound() {
  return (
    <div>
      <h1>Page non trouvée !</h1>
    </div>
  );
}

export default NotFound;
